<template>
  <WidthDimensionLine :y="6" :x1="20" :x2="22" />
  <WidthDimensionLine :y="6" :x1="30.3" :x2="31.8" />
  <HeightDimensionLine :y1="12" :x="52" :y2="22" />
  <HeightDimensionLine :y1="15" :x="66.4" :y2="52" />
</template>
